import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'kt-alert-entity-dialog',
  templateUrl: './alert-entity-dialog.component.html',
  styleUrls: ['./alert-entity-dialog.component.scss']
})
export class AlertEntityDialogComponent implements OnInit {

  @Input() duration: number = 0;
  @Input() showCloseButton: boolean = true;
  alertShowing: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<AlertEntityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.duration === 0) {
      return;
    }
    setTimeout(() => {
      this.closeAlert();
    }, this.duration);
  }
  closeAlert() {
    this.dialogRef.close();
  }

}
